import React, { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomHelmet from "../../component/reusable/Helmet";
import { FaArrowLeftLong } from "react-icons/fa6";
import lecturette1 from "../../images/howuse/lecturete1.png";
import lecturette2 from "../../images/howuse/lecturete2.png";
import lecturette3 from "../../images/howuse/lecturete3.png";
import lecturette4 from "../../images/howuse/lecturete4.png";
import lecturette5 from "../../images/howuse/lecturete5.png";
import lecturette6 from "../../images/howuse/lecturete6.png";
import ssb_mentor_1 from "../../images/howuse/ssb_mentor_1.png";

const LecturetteHowUse = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <CustomHelmet
        title="SSB-GPT: Your SSB Interview Self Preparation Tool"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      {/* <GptHeader /> */}

      <section className="how_UseClassRoom_main">
        <div className="container">
          <div className="bacbtnWthHeading">
            <button
              title="back"
              className="backBtn"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeftLong />
            </button>
            <h1 className="main_heading">How to Use Lecturette Classroom</h1>
          </div>
        </div>
        <div className="howUse_content container">
          <p>Welcome, Alpha Warriors!</p>
          <br />
          <p>
            The Lecturette is a crucial part of the SSB process, assessing your
            ability to think on your feet, organize thoughts, and communicate
            effectively. It’s your opportunity to showcase confidence, clarity,
            and Officer-Like Qualities (OLQs) while speaking on a given topic.
          </p>
          <br />
          <p>
            To help you prepare, AI SSB Mentor Captain Alpha will conduct mock
            lecturette sessions, simulating real SSB scenarios. These sessions
            are designed to refine your delivery, enhance your confidence, and
            provide expert feedback to help you excel in your lecturette.{" "}
          </p>
          <br />
          <p>
            Get ready to train and master your lecturette skills under the
            guidance of Captain Alpha! 🚀
          </p>
          <br />
          <p>Here’s how you can join and start practicing:</p>
          <h2 className="subHeading">
            Step-by-Step Guide to Join the Lecturette Classroom
          </h2>
          <h3 className="tab_heading">
            <b>Step 1.</b> Navigate to the Home Page {`>>`}{" "}
            <Link to="/chat">Ask Your SSB Mentor Now</Link>{" "}
          </h3>
          <img
            src={ssb_mentor_1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 2.</b> Click <b>“Choose Classroom”</b>
          </h3>
          <img
            src={lecturette1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 3.</b> Choose <b>“Lecturette”</b>
          </h3>
          <img
            src={lecturette2}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 4.</b> Click the <b>“Start”</b> button
          </h3>
          <img
            src={lecturette3}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />

          <h3 className="tab_heading">
            <b>Step 5.</b> Read the instructions carefully and Click the “Start”
            button
          </h3>
          <p>
            Read the instructions carefully so that your Lecturette session can
            run smoothly without any interruption. Click on the “Start” button.{" "}
          </p>
          <img
            src={lecturette4}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <h3 className="tab_heading">
            <b>Step- 6.</b> Choose Topic
          </h3>
          <p>
            Choose any one topic out of the four provided and create a mental
            mind map and structure outlining how you will deliver your
            lecturette. As soon as you see the next page, begin delivering your
            lecturette.
          </p>
          <img
            src={lecturette5}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <h3 className="tab_heading">
            <b>Step- 7.</b> Familiarize yourself with your classroom interface
          </h3>

          <img
            src={lecturette6}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <br />
          <br />
          <ul>
            <li>
              Whatever you speak will be automatically transcribed here. If you
              notice any errors due to background noise, misinterpretation, or
              other reasons, you can correct them before submitting.
            </li>
            <li>
              If the automatic transcription stops for any reason, click the mic
              icon to refresh it.
            </li>
            <li>
              Once you’ve ensured your answer is correctly typed, click Submit.
            </li>
            <li>
              On the top-right corner, you'll find a timer designed to help you
              practice in a real-time, time-bound environment.
            </li>
          </ul>
          <br />
          <p>
            This way, your mock lecturette practice can continue seamlessly for
            as long as you need.
          </p>
          <br />
          <p>
            By following these steps, you can ensure a smooth and productive
            preparation for your Lecturette. For further assistance, feel free
            to reach out to support!
          </p>
          <br />
          <p>
            Jai Hind! <br />
            Over and out!
          </p>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
};

export default LecturetteHowUse;
